import { render, staticRenderFns } from "./CustomerOpportunityCard.vue?vue&type=template&id=0b218c41&scoped=true&"
import script from "./CustomerOpportunityCard.vue?vue&type=script&lang=js&"
export * from "./CustomerOpportunityCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOpportunityCard.vue?vue&type=style&index=0&id=0b218c41&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b218c41",
  null
  
)

export default component.exports